import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Consts } from '@shared/consts';
import { GlobalSettings } from '@core/globalSettings.service';
import { SessionInfo } from '../authentication/auth.service';
import { faUnderline } from '@nodeModules/@fortawesome/free-solid-svg-icons';

@Injectable({
	providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {

	constructor() {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// Get settings for custom headers only
		// The @itero/auth-angular interceptor handles Authorization header and token refresh
		const settings = this.getSessionSettings();
		
		// Add only custom headers if available
		if (settings.contactId && settings.contactId > 0) {
			request = this.setHeader(request, Consts.HeaderKeys.LogonAsId, settings.contactId);
		}
		if (settings.selectedCompanyId && settings.selectedCompanyId > 0) {
			request = this.setHeader(request, Consts.HeaderKeys.SelectedCompanyId, settings.selectedCompanyId);
		}
		if (settings.selectedDoctorId && settings.selectedDoctorId > 0) {
			request = this.setHeader(request, Consts.HeaderKeys.SelectedDoctorId, settings.selectedDoctorId);
		}

		const sessionInfo = this.getSessionInfo();
		if (sessionInfo?.sessionId?.trim()) {
			request = this.setHeader(request, Consts.HeaderKeys.SessionId, sessionInfo.sessionId);
		}

		return next.handle(request);
	}

	private setHeader(request: HttpRequest<any>, headerKey: string, headerValue: any) {
		const headers = request.headers.set(headerKey, headerValue.toString());
		return request.clone({ headers });
	}

	private getSessionSettings(): GlobalSettings {
		const settings = localStorage.getItem(Consts.Storage.Settings);
		try {
			return JSON.parse(settings) as GlobalSettings || new GlobalSettings();
		} catch {
			return new GlobalSettings();
		}
	}

	private getSessionInfo(): SessionInfo {
		const sessionInfo = localStorage.getItem(Consts.Storage.SessionInfo);
		try {
			return JSON.parse(sessionInfo) as SessionInfo || undefined;
		} catch {
			return undefined;
		}
	}
}
